import { makeStyles } from "@material-ui/core";
export const usePartnerManagerStyles = makeStyles(() => ({
    paper: {
        width: "100%",
        position: "relative"
    },
}));
